import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./styles.css";
import { useSelector } from "react-redux";

import {
    tytErp,
    tytNomina,
    tytCfdi
} from "./iconosProductosCarrito/iconosProductosCarrito";
import { redondeo, toFixed } from "helpers/regexp";

export default function Carrito(props) {
    let { registros } = props;
    const { usuario, token } = useSelector(state => state.login);
    const history = useHistory();
    const noTruncarDecimales = { maximumFractionDigits: 20,  style: 'currency', currency: 'MXN' };


    const [viewCarrito, setViewCarrito] = useState();

    function cartView() {
        let view = [];
        let aux;
        if (registros?.length == 0) {
            return <>No hay nada en el carrito</>;
        } else {
            registros.map(element => {
                
                let precio = element.precioVentaOnline !== null ?  parseFloat(toFixed(element.precioVentaOnline, 2))
                    : 0;
                    precio = redondeo(precio, 2);
                    precio = parseFloat(precio).toLocaleString("es-MX", noTruncarDecimales);
                    let costoPaquete = precio;
                        aux = (
                            <div className="contenedorProductoCarrito">
                                <div className="contenedorLogoProductoCarrito">
                                    <img src={element.imagenPortada} />
                                </div>
                                <div className="contenedorDescripcionProductoCarrito">
                                    <h4>{`${element.producto}`}</h4>
                                    <h5>
                                        {`PAQUETE: ${element.tipoPaquete} ${element.plazoPaquete}`}
                                    </h5>
                                    <h4>
                                        {`PRECIO: ${costoPaquete}`}
                                    </h4>
                                </div>
                            </div>
                        );

                        view.push(aux);
            })
        }
        return view;
    }

    function cartTotal() {
        if (registros?.length == 0) {
            return 0;
        } else {
            let aux;
            let totalArr = [];
            let total = 0;

            registros.map(precio => {
                aux = precio.precioVentaOnline;
                totalArr.push(aux);
            });

            for (let i = 0; i < totalArr.length; i++) {
                total += totalArr[i];
            }

            let precio = total !== null ?  parseFloat(toFixed(total, 2))
                    : 0;
                    precio = redondeo(precio, 2);
                    precio = parseFloat(precio).toLocaleString("es-MX", noTruncarDecimales);
                    let costoPaquete = precio;

            return costoPaquete;
        }
    }

    const routeShoppingCart = () =>{
        let path = `/shoppingCart/${token}`;
        history.push(path);
        window.location.reload();
      }

    return (
        <>
            <div className="contenedorGeneralPreviewCarrito">
                <ul className="listadoProductosCarrito">{cartView()}</ul>

                <div className="totalProductosCarrito">
                    {`Total: ${cartTotal()}`}
                </div>

                {/* <div className="procederPagoCarrito" onClick={routeShoppingCart}>Modificar carrito</div> */}
            </div>
        </>
    );
}
